import React, {FC, useContext, useEffect} from 'react';
import { useScrollToTop } from "../../../../../hooks/useScrollToTop";
import { ThemeContext } from '../../../../../context/data/ThemeContext';
import { ReactComponent as HeaderSeparator } from '../../../../../assets/images/svg/header-separator.svg';
import HeaderTop from './HeaderTop';
import useBodyClass from "../../../../../hooks/useBodyClass";
import './Header.style.scss';

const ServiceHeader: FC<any> = props => {
    useScrollToTop();
    const { setThemeWrapperClassName } = useBodyClass();
    const { breadcrumb, pageTitle } = useContext<any>(ThemeContext);

    useEffect(() => {
        setThemeWrapperClassName('public-theme-wrapper');
    }, []);

    return (
        <header>
            <HeaderTop />
            {breadcrumb.component}
            <div className="my-3 text-center container">
                <h2 className="page-title h3 mb-1">
                    {pageTitle}
                </h2>
                <HeaderSeparator aria-hidden="true" />
            </div>
        </header>
    );
}

export default React.memo(ServiceHeader);
